import styled from "@emotion/styled";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";

import { fontRoboto, fontRobotoCondensed } from "shared/lib/styles";
import { theme } from "shared/lib/styles/theme";

import ArrowIcon from "./arrow.svg";

export const StyledAccordion = styled(Accordion)`
  ${".MuiAccordionSummary-root"} {
    padding-block: 8px;
    padding-inline: 16px;

    ${theme.breakpoints.up("tablet")} {
      padding-block: 8px;
      padding-inline: 20px;
    }
  }

  ${".MuiAccordionSummary-content"} {
    margin-block: 0;
  }

  :not(:first-of-type) {
    border-block-start: 1px #dfdfdf solid;
  }

  ::before {
    background-color: transparent;
  }
`;

export const StyledAccordionSummary = styled(AccordionSummary)``;

export const StyledArrowIcon = styled(ArrowIcon)`
  transform: rotate(180deg);
`;

export const StyledAccordionDetails = styled(AccordionDetails)`
  padding-block: 16px;
  padding-inline: 35px;

  background-color: #f8f8f8;

  ${theme.breakpoints.up("tablet")} {
    padding-block: 16px;
    padding-inline: 44px;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  column-gap: 12px;

  ${theme.breakpoints.up("tablet")} {
    column-gap: 16px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  column-gap: 12px;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    column-gap: 16px;
    align-items: center;
  }
`;

export const Index = styled.div`
  color: #333333;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 140%;
  font-variant-numeric: lining-nums proportional-nums;
`;

export const Title = styled.div`
  color: #333333;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 140%;
  font-variant-numeric: lining-nums proportional-nums;

  ${theme.breakpoints.up("tablet")} {
    font-size: 16px;
  }
`;

export const Count = styled.div`
  color: #888888;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};

  span {
    font-weight: bold;
  }
`;

export const ExpertPerspectiveHeader = styled.div`
  margin-block-start: 8px;
  padding-block-start: 20px;
  border-block-start: 1px solid #dfdfdf;

  color: #666666;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  text-transform: uppercase;

  :first-child {
    margin-block-start: 0;
    padding-block-start: 12px;
    border-block-start: none;
  }
`;
